<footer class="footer">
  <div class="dev">
    <span>Всі права захищені ГО "ТЕНІС-МІКС".</span> Розробив <a href="https://www.linkedin.com/in/yaroslav-oshyyko-900a28109/" target="_blank">Ярослав Ошийко</a>
  </div>
</footer>

